import { useAuthContext } from "@contexts/authContext"
import { colors, fontSize } from "@styles/theme"
import { TopButton } from "./SocialElements"
import styled from '@emotion/styled'

const StyledButton = styled(TopButton)`
  font-size: ${fontSize('sm')};
`

const FollowButton = ({ styles, disabled, followUser, unfollowUser, profile }) => {
  const { state: authState } = useAuthContext()
  const isAnonymous = authState?.user?.isAnonymous

  const renderFollowingStyles = () => {
    let styles = {}
    if (!profile?.imFollowing && profile?.followingMe) {
      styles = {
        backgroundColor: colors.statusColors.right_now('primary'),
        color: 'white'
      }
    } else if (!profile?.imFollowing) {
      styles = {
        backgroundColor: 'white',
        color: 'black'
      }
    }
    return styles
  }

  return (
    <StyledButton
      disabled={disabled || isAnonymous}
      style={{
        opacity: (disabled || isAnonymous) ? 0.4 : 1,
        ...renderFollowingStyles(),
        ...styles,
      }}
      onClick={() => profile.imFollowing ? unfollowUser() : followUser()}
      isActive={!profile?.imFollowing}>
      {profile?.imFollowing ? 'Following' : (profile?.followingMe ? '+ Follow Back' : 'Follow')}
    </StyledButton>
  )
}

export default FollowButton
